// Return the number of decimals after the point in any decimal number
function countDecimals(value) {
  if (!value) return 0
  const text = value.toString()
  // count decimals for number in representation like "0.123456"
  if (Math.floor(value) !== value) {
    return text.split('.')?.[1]?.length || 0
  }
  return 0
}

export { countDecimals }
